import React from 'react';
import { Skeleton } from '../skeleton/skeleton';

export const RecommendedProductsCarouselItemSkeleton = () => {
    return (
        <div className='recommended-product-card recommended-product-card--loading'>
            <div className='recommended-product-card__image-wrapper'>
                <Skeleton />
            </div>

            <div className='recommended-product-card__info'>
                <div className='recommended-product-card__title'>
                    <Skeleton />
                </div>
                <div className='recommended-product-card__price'>
                    <Skeleton />
                </div>
                <div className='recommended-product-card__cta'>
                    <Skeleton className='recommended-product-card__cta-text-skeleton' />
                    <Skeleton className='recommended-product-card__cta-icon-skeleton' />
                </div>
            </div>
        </div>
    );
};
